import { render, staticRenderFns } from "./OotdEpisode1.vue?vue&type=template&id=498b7fbb&"
import script from "./OotdEpisode1.vue?vue&type=script&lang=js&"
export * from "./OotdEpisode1.vue?vue&type=script&lang=js&"
import style0 from "./OotdEpisode1.vue?vue&type=style&index=0&id=498b7fbb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports